import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/iam')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/iam', ...ROUTE_META['/platform/iam'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'IAM', path: '/platform/iam' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/iam', ...ROUTE_META['/platform/iam'] })),
    ],
  }),
});
